import apiFetch from '../apiFetch'

export default function (idEnvasado, token) {
  return apiFetch({endPoint: `Envasado/getEnvasado?idEnvasado=` + idEnvasado, method: 'GET', body: null, token: token})
}
